module.exports = __webpack_public_path__ + "static/media/N04.aa02175d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbs/decors/N04.png
// module id = 239
// module chunks = 0